import { RoutingGuideRule } from '../routingGuide/RoutingGuideRule';

import { RateQuote } from './RateQuote';
import { RateShopStatus } from './RateShopStatus';
import { RoutingGuideClassification } from './RoutingGuideClassification';

export class RateShop {
  id?: number;
  allRateQuotes: RateQuote[] = [];
  routingGuideRule?: RoutingGuideRule;
  requiresReRate: boolean = false;
  status?: RateShopStatus;

  constructor(opts?: Partial<RateShop>) {
    if (opts?.id != null) {
      this.id = opts.id;
    }
    if (opts?.rateQuotes != null) {
      this.allRateQuotes = opts.rateQuotes.map((val) => new RateQuote(val));
    }
    if (opts?.routingGuideRule != null) {
      this.routingGuideRule = new RoutingGuideRule(opts.routingGuideRule);
    }
    if (opts?.requiresReRate != null) {
      this.requiresReRate = opts.requiresReRate;
    }
    if (opts?.status != null) {
      this.status = opts.status;
    }
  }

  /// A carrier that answered with an error is not a quote anyone can act on, so it is kept out of
  /// rateQuotes and consumers see only what they can price, select or tender.
  get rateQuotes(): RateQuote[] {
    return this.allRateQuotes.filter((q) => q.rateStatus !== 'ERROR');
  }

  get rateErrors(): RateQuote[] {
    return this.allRateQuotes.filter((q) => q.rateStatus === 'ERROR');
  }

  get brokerageQuote(): RateQuote | undefined {
    return this.rateQuotes.find((r) => r.source === 'BROKERAGE');
  }

  get nonBrokerageQuotes(): RateQuote[] {
    return this.rateQuotes.filter((r) => r.source !== 'BROKERAGE');
  }

  get preferredQuotes(): RateQuote[] {
    return this.rateQuotes.filter(
      (r) =>
        r.routingGuideClassification === RoutingGuideClassification.PREFERRED,
    );
  }

  get excludedQuotes(): RateQuote[] {
    return this.rateQuotes.filter(
      (r) =>
        r.routingGuideClassification === RoutingGuideClassification.EXCLUDED,
    );
  }

  get standardQuotes(): RateQuote[] {
    return this.rateQuotes.filter(
      (r) =>
        r.routingGuideClassification === RoutingGuideClassification.STANDARD,
    );
  }
}
